import { type CustomIntegrationAuthType } from '../../../models/CustomIntegration'

export interface AuthTypeOption {
  type: CustomIntegrationAuthType
  label: string
  description: string
}

export const AUTH_TYPE_OPTIONS: AuthTypeOption[] = [
  { type: 'none', label: 'No Auth', description: 'No authorization required, once saved the MCP server will appear in the Custom MCP section.' },
  { type: 'oauth2Dcr', label: 'Dynamic Client Registration', description: 'The server handles OAuth client registration automatically' },
  { type: 'oauth2', label: 'Manual setup', description: 'You provide all the authentication values required for the connection.' },
  { type: 'apiKey', label: 'API key', description: 'Each user provides a personal API key that Zocks sends in a request header.' },
  { type: 'bearer', label: 'Bearer token', description: 'Each user provides a personal token that Zocks sends as a Bearer authorization header.' },
  { type: 'basic', label: 'Basic auth', description: 'Each user provides a username and password for HTTP Basic authentication.' },
]

export const authTypeLabel = (authType: CustomIntegrationAuthType): string => AUTH_TYPE_OPTIONS.find((option) => option.type === authType)?.label ?? authType

export const AUTH_DETAILS_SUBTITLE = 'Provide optional information if needed and authorize your connection'
